module.exports = __webpack_public_path__ + "img/EISEnglish_logoWhite.4c04c754.png";